module.exports = __webpack_public_path__ + "static/media/n-fun-cards.aebffa0f.webp";